import api from './api';

export const mensagemService = {
  enviar: (instanciaId: string, numero: string, mensagem: string) =>
    api.post(`/mensagens/${instanciaId}/enviar`, { numero, mensagem }),
  enviarArquivo: (instanciaId: string, numero: string, arquivo: string, legenda: string) => {
    const formData = new FormData();
    formData.append('arquivo', arquivo);
    formData.append('numero', numero);
    formData.append('legenda', legenda || '');
    return api.post(`/mensagens/${instanciaId}/enviar-arquivo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  listarConversa: (instanciaId: string, numero: string) =>
    api.get(`/mensagens/${instanciaId}/conversa/${numero}`),
  deletar: (remoteJid: string, messageId: string, instanciaId?: string) => {
    const params = new URLSearchParams({
      remoteJid: encodeURIComponent(remoteJid),
      messageId: encodeURIComponent(messageId),
    });
    if (instanciaId) {
      params.append('instanciaId', instanciaId);
    }
    return api.delete(`/mensagens/delete-message?${params.toString()}`);
  },
  editar: (id: string, text: string, remoteJid: string) =>
    api.put('/mensagens/edit-message', { id, text, remoteJid }),
};
